import { useImage, useImageProps } from 'react-image';

/**
 * Coalesce image urls and get a default url until
 * the images are loaded.
 */
export function useDefaultImage({
  defaultSrc = null,
  ...props
}: useImageProps & { defaultSrc?: string }) {
  const image = useImage(props);
  if (defaultSrc && !image.src) {
    image.src = defaultSrc;
  }
  return image;
}

/**
 * Get a url for the company logo
 * @param vtrId The VTR id to get the src.
 * @param tmdb The tmdb url if any.
 */
export function useCompanyLogo(vtrId: string, tmdb: string = '') {
  const defaultLogo = 'default logo icon';
  return useDefaultImage({
    srcList: ['image by vtr_id' + vtrId, 'tmdb' + tmdb, defaultLogo],
    defaultSrc: defaultLogo,
  });
}
